import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import type { AdminDeleteWalletTransactionRequest } from "@shopexperts/legacy-api";

interface DeleteAdminWalletTransactionInput {
  transactionId: number;
  organizationId?: number | null;
  body?: AdminDeleteWalletTransactionRequest;
}

export function useDeleteAdminWalletTransaction() {
  const api = useApi();
  const toaster = useToaster();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["admin", "wallet", "deleteTransaction"],
    mutationFn: async ({ transactionId, body }: DeleteAdminWalletTransactionInput) => {
      return await api.admin.wallet.deleteTransaction({
        params: { transaction: transactionId },
        body: body ?? {},
      });
    },
    onSuccess: (_transaction, variables) => {
      toaster.create({ title: "Wallet transaction deleted successfully", type: "success" });
      queryClient.invalidateQueries({ queryKey: ["admin", "wallet", "transactions"] });
      if (variables.organizationId) {
        queryClient.invalidateQueries({ queryKey: ["admin", "wallet", "organization", variables.organizationId] });
        queryClient.invalidateQueries({ queryKey: ["admin", "wallet", "organization", variables.organizationId, "level"] });
        queryClient.invalidateQueries({
          queryKey: ["admin", "wallet", "organization", variables.organizationId, "transactions"],
        });
      }
    },
    onError: (error: Error) => {
      toaster.create({ title: `Failed to delete wallet transaction: ${error.message}`, type: "error" });
    },
  });
}
